import { Handler } from 'mitt';
import { isEmpty } from 'lodash';
import { format } from 'url';

type NavigateToType = { href: string | URL; target: '_self' | '_blank' };

const navigateTo: Handler<NavigateToType> = ({ href, target = '_self' }) => {
  if (isEmpty(href)) {
    return;
  }
  const outgoingPath = typeof href === 'string' ? href : format(href as URL);
  window.open(outgoingPath, target as string);
};

export default navigateTo;
